import { render, staticRenderFns } from "./personInforManage.vue?vue&type=template&id=3edc97b6&scoped=true&"
import script from "./personInforManage.vue?vue&type=script&lang=js&"
export * from "./personInforManage.vue?vue&type=script&lang=js&"
import style0 from "./personInforManage.vue?vue&type=style&index=0&id=3edc97b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc97b6",
  null
  
)

export default component.exports